<div id="content">
  <div class="grid-holder">
    <table id="wrap" style="white-space: nowrap; background-color: #efefef">
      <tr>
        <td>
          <div style="width: 100%; height: 100%; position: relative" id="div1">
            <table
              id="tt"
              class="easyui-datagrid"
              style="width: 800px; height: 400px"
              title=""
            ></table>
          </div>
        </td>
      </tr>
    </table>

    <!-- add ng if for fremium user and disable InspectorClick button -->
    <div id="tblIns" *ngIf="view != 'SAR'">
      <div onclick="InspectorClick(true, 'Lineitem')">
        <img
          class="arrow-circle-up inspector-arrow"
          src="{{ assetUrl }}/circular_arrow_up.png"
          alt="Up"
        />
      </div>
    </div>
  </div>

  <div
    class="context-menu mex-context-menu"
    id="chart-context-menu"
    style="display: none"
    [ngStyle]="{ visibility: invisibleMenu ? 'hidden' : 'visible' }"
  >
    <div
      style="
        padding: 16px 0px 20px 16px;
        border-radius: 3px;
        width: 200px;
        border: solid 1px #36abad;
        font-size: 12px;
        line-height: 1.5;
        box-shadow:
          0 4px 4px 0 rgba(126, 126, 126, 0.16),
          0 0 2px 1px rgba(0, 0, 0, 0.12),
          0 4px 8px -4px rgba(0, 0, 0, 0.16);
        background-color: #ffffff;
      "
    >
      <ng-container *ngIf="(cut === 'NMV' || cut === 'STD') && !nmvSliMapReady">
        <ul nz-menu>
          <li
            *ngFor="let dummySection of [0, 1, 2, 3, 4, 5]"
            style="padding: 0px 15px 0px 15px"
          >
            <nz-skeleton
              [nzTitle]="true"
              [nzActive]="true"
              [nzParagraph]="false"
            ></nz-skeleton>
          </li>
        </ul>
      </ng-container>
      <ng-container
        *ngIf="
          (cut !== 'NMV' && cut !== 'STD') ||
          ((cut === 'NMV' || cut === 'STD') && nmvSliMapReady)
        "
      >
        <div style="font-weight: bold; color: #222222">Shortcuts:</div>
        <div style="padding: 4px 0px 8px 12px; color: #1874ae">
          <div
            value="Audit"
            class="context-item context-menu-audit"
            style="padding: 0px 0px 2px 8px; border-left: 4px solid transparent"
            *ngIf="!isLineItemContextMenu"
            (click)="onAuditFormulaClick()"
          >
            Audit Formula
          </div>
          <div
            class="context-item context-menu-vaexcel"
            ng-class="{
              'context-menu-options-disabled': allowVAExcelCopyOption == false
            }"
            value="VAFormula"
            data-clipboard-text=" "
            *ngIf="!customOrCPlusSource && !isLineItemContextMenu"
            style="
              padding: 0px 12px 2px 8px;
              border-left: 4px solid transparent;
            "
          >
            <div *ngIf="allowVAExcelCopyOption" (click)="copyExcelAddin()">
              Copy Add-In Formula
              <span style="float: right">
                <va-icon size="small" name="copy"></va-icon>
              </span>
            </div>
            <div *ngIf="!allowVAExcelCopyOption">
              Add-in Formula Unavailable
            </div>
          </div>
          <ng-container>
            <div
              class="context-item context-menu-addToMonitor"
              value="addLineMonitor"
              *ngIf="cut === 'NMV'"
              (click)="addToMonitor()"
              style="
                padding: 0px 12px 2px 8px;
                border-left: 4px solid transparent;
              "
            >
              Add to Line Item Monitor
            </div>
            <div
              class="context-item context-menu-compareToPeer"
              value="compareToPeer"
              *ngIf="
                isLineItemContextMenu &&
                isCompareToPeer == true &&
                cut !== 'STD' &&
                cut !== 'SCH'
              "
              style="
                padding: 0px 12px 2px 8px;
                border-left: 4px solid transparent;
              "
            >
              Compare to Peers
            </div>
            <div
              *ngIf="isLineItemContextMenu && cut === 'SAR'"
              class="context-item context-menu-copyLineItemCode"
              value="copyLineItemCode"
              data-clipboard-text=" "
              (click)="copyLineItemCode()"
              style="
                padding: 0px 12px 2px 8px;
                border-left: 4px solid transparent;
              "
            >
              Copy Line Item Code
            </div>
            <div
              *ngIf="isLineItemContextMenu"
              id="options-refresh-buttons-apply-GrowthTypes-yoyPercent"
              class="context-item analytic-inclusion"
              (click)="onChangeAnalyticInclusion('YoY%', $event)"
            >
              Year over Year (%)
            </div>
            <div
              *ngIf="showAsPctOfOption && isLineItemContextMenu"
              id="options-refresh-buttons-apply-GrowthTypes-asPercentOf"
              class="context-item analytic-inclusion"
              (click)="onChangeAnalyticInclusion('%', $event)"
              title="As % of {{ showAsPctOfOption }}"
            >
              {{ "As % of " + showAsPctOfOption | textEllipsis: 22 }}
            </div>
          </ng-container>
        </div>
        <div
          style="font-weight: bold; color: #222222"
          *ngIf="
            !customOrCPlusSource && !isLineItemContextMenu && cut !== 'SAR'
          "
        >
          {{ ticker }} Charts
        </div>
        <div
          style="padding: 4px 0px 8px 12px; color: #1874ae"
          *ngIf="
            !customOrCPlusSource && !isLineItemContextMenu && cut !== 'SAR'
          "
        >
          <div
            class="context-menu-options charts context-item context-menu-revision"
            value="trend"
            *ngIf="cut !== 'SAR' && !customOrCPlusSource"
            style="padding: 0px 0px 2px 8px; border-left: 4px solid transparent"
          >
            Trend
          </div>
          <div
            class="context-menu-options charts context-item context-menu-revision"
            value="revision"
            *ngIf="showRevision && cut !== 'SAR'"
            style="padding: 0px 0px 2px 8px; border-left: 4px solid transparent"
          >
            Revision
          </div>
          <div
            class="context-menu-options charts context-item context-menu-distribution"
            value="Distribution"
            *ngIf="showDistribution"
            style="padding: 0px 0px 2px 8px; border-left: 4px solid transparent"
          >
            Distribution
          </div>
          <div
            class="context-menu-options charts context-item context-menu-surprise"
            value="Surprise"
            *ngIf="showSurprise"
            style="padding: 0px 0px 2px 8px; border-left: 4px solid transparent"
          >
            Surprise
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div #biopharmaContextMenu class="pharmaMenu"></div>
</div>

<app-chart-popup
  [chartType]="chartType"
  [dataToUse]="dataUsed"
  [(showPopup)]="chartReady"
  (closePopup)="hideChartPopup()"
  [beginningStateReferrer]="beginningStateReferrer"
  [closeFeature]="feature"
></app-chart-popup>
<app-research-insight-popup
  [(ticker)]="ticker"
  [(dapParamObj)]="currentDapObj"
  [(showPopup)]="showResearchPopup"
  (closePopup)="hideResearchInsightPopup()"
></app-research-insight-popup>
<div
  class="popupBlockUI"
  style="
    display: none;
    border: none;
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    opacity: 0.6;
    cursor: default;
    position: fixed;
    z-index: 100;
    background-color: rgb(0, 0, 0);
  "
></div>
<div id="mex-loader" *ngIf="showLoader">
  <ng-template #indicatorTemplate>
    <div class="loader_image_clear_all">
      <img class="loader-image" src="{{ assetUrl }}/spinner-blue.gif" />
      <div id="clear_all_block_ui" *ngIf="showLoaderClearAll">
        <span style="font-size: 13px; color: #454b4d"
          >Loading taking too long? </span
        ><br />
        <a
          id="option_clear"
          style="cursor: pointer; color: #1874ae; font-size: 13px"
          (click)="callDefaultSetting()"
          >Clear all settings</a
        >
      </div>
    </div>
  </ng-template>
  <nz-spin [nzSpinning]="showLoader" nzSimple [nzIndicator]="indicatorTemplate">
  </nz-spin>
</div>

<ng-template #snackbarTemplateAddToMonitor>
  <span
    >{{ responseMessage }}
    <span (click)="redirectToMonitor()" class="open-lim-link"
      >&nbsp;&nbsp;<u>Open Line Item Monitor </u></span
    >
    {{ messageSuffix }}
  </span>
</ng-template>
